var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNormalStrip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 211,
    viewBox: "0 0 46 211",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32991",
    "data-name": "Group 32991",
    transform: "translate(-4236 -4472)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26761",
    "data-name": "Rectangle 26761",
    width: 46,
    height: 211,
    transform: "translate(4236 4472)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26762",
    "data-name": "Rectangle 26762",
    width: 46,
    height: 5,
    transform: "translate(4236 4517)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26763",
    "data-name": "Rectangle 26763",
    width: 46,
    height: 5,
    transform: "translate(4236 4531)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26764",
    "data-name": "Rectangle 26764",
    width: 46,
    height: 5,
    transform: "translate(4236 4581)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26765",
    "data-name": "Rectangle 26765",
    width: 46,
    height: 5,
    transform: "translate(4236 4595)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26766",
    "data-name": "Rectangle 26766",
    width: 46,
    height: 6,
    transform: "translate(4236 4645)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26767",
    "data-name": "Rectangle 26767",
    width: 46,
    height: 5,
    transform: "translate(4236 4657)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26768",
    "data-name": "Rectangle 26768",
    width: 46,
    height: 5,
    transform: "translate(4236 4670)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26769",
    "data-name": "Rectangle 26769",
    width: 46,
    height: 5,
    transform: "translate(4236 4678)",
    fill: "#333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormalStrip);
export default __webpack_public_path__ + "static/media/normalStrip.953351c38602ced99b83da15d471a7ed.svg";
export { ForwardRef as ReactComponent };